export default __webpack_public_path__ + "static/media/thankyoucalender.30241be6.svg";